<template>
<div>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <slot name="title">Default Title</slot>
        </h1>
        <p class="mt">
          <slot name="subtitle">Wanon Niwat Hospital [WEBPORTAL WNH]</slot>
        </p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="bi bi-house-door fs-6"></i></li>
        <li class="breadcrumb-item">
        <router-link to="/">
          <slot name="breadcrumb">หน้าหลัก</slot>
        </router-link>
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <slot name="header">Default Title</slot>
          <div class="tile-body">
            <slot name="content">Default Content</slot>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
</template>

<script>
export default {
  name: 'MainContent',
};
</script>

<style scoped>
/* Add your styles here */
</style>